var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatient(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8,0C3.6,0,0,3.6,0,8c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8C16,3.6,12.4,0,8,0z M8,15c-3.9,0-7-3.2-7-7 c0-3.9,3.2-7,7-7c3.9,0,7,3.2,7,7C15,11.9,11.9,15,8,15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2,9.5h-0.6l-1-1.1C10.3,8,9.9,7.8,9.4,7.8H8.6C8.3,7.8,8,7.6,8,7.3V6.7h1.3c0.3,0,0.5-0.2,0.5-0.5 c0-0.3-0.2-0.5-0.5-0.5H8V5.3c0.4-0.2,0.8-0.6,0.8-1.1c0-0.7-0.6-1.2-1.2-1.2S6.3,3.4,6.3,4.1c0,0.5,0.3,0.9,0.8,1.1v2 c0,0.8,0.7,1.5,1.5,1.5h0.9c0.2,0,0.3,0.1,0.4,0.2l1.1,1.3c0.1,0.1,0.2,0.2,0.4,0.2h0.8c0.3,0,0.5-0.2,0.5-0.5S12.5,9.5,12.2,9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1,10.2c-0.2-0.1-0.5,0-0.7,0.2c-0.5,1-1.6,1.4-2.7,1.2c-0.9-0.2-1.6-0.9-1.8-1.9C4.7,8.6,5.2,7.5,6.2,7 c0.2-0.1,0.3-0.4,0.2-0.7C6.3,6.1,6,6,5.8,6.1C4.4,6.8,3.6,8.3,3.9,9.9c0.3,1.3,1.3,2.3,2.6,2.6c0.3,0.1,0.5,0.1,0.8,0.1 c1.2,0,2.4-0.7,3-1.8C10.4,10.6,10.3,10.3,10.1,10.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatient);
export default __webpack_public_path__ + "static/media/patient.3f64c578a039acf955139817af74f888.svg";
export { ForwardRef as ReactComponent };